export const nameToAvatar = (name: string) => {
    const splitName = name.split(" ");
    let avatarName = "";
    if (splitName.length === 1) {
        avatarName = splitName[0][0] + splitName[0][1];
    } else {
        avatarName = splitName[0][0] + splitName[1][0];
    }

    return avatarName;
};
